import {observable, computed, autorun, map} from 'mobx';

const allowedTypes = ['Int','Double','Bool','String'];

// Some helper methods:
function isInt(value) {
  var x;
  if (isNaN(value)) {
    return false;
  }
  x = parseFloat(value);
  return (x | 0) === x;
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function isBoolean(variable) {
  return typeof(variable) === "boolean"
}

// A single configurable parameter for a deconx machine
class MachineConfigParameter {
  @observable value;

  constructor(id_property, id_type, default_value, value) {
    if(allowedTypes.indexOf(id_type)==-1) throw new Error("Invalid property type");
    this.id_property = id_property;
    this.id_type = id_type;
    this.default_value=default_value;
    this.value=value;
  }

  @computed get valueObject() {
    return {"id_param":this.id_property,"value":this.value};
  }

  @computed get computed_value() {
    if(this.value == null) return this.default_value;
    return this.value;
  }

  @computed get display_value() {
    let val = this.computed_value;
    if(isBoolean(val)) return val ? "Enabled" : "Disabled";
    return ""+val;
  }

  @computed get value_valid() {
    // Empty values are OK, as they will fall back to valid defaults:
    if(this.value == null) return true;
    if(this.value == "") return true;
    // Non-empty values must parse:
    if(this.id_type=='Int') return isInt(this.value);
    if(this.id_type=='Double') return isNumeric(this.value);
    if(this.id_type=='Bool') return isBoolean(this.value);
    // accept the rest
    return true;
  }

  @computed get invalid_message() {
    return this.value + " is not a valid "+this.id_type;
  }

  clone() {
    return new MachineConfigParameter(
      this.id_property,
      this.id_type,
      this.default_value,
      this.value
    );
  }
}

// This maps a config property object as returned from the db as part of
// machine details lookup to the MachineConfigParameter type
function createMachineConfigParameterFromDBRow(row) {
    return new MachineConfigParameter(
      row.id_param,
      row.id_param_type,
      row.default_value,
      row.value
    );
}

MachineConfigParameter.createFromDBRow=createMachineConfigParameterFromDBRow;

export default MachineConfigParameter;



/** WEBPACK FOOTER **
 ** ./src/DataModel/MachineConfigParameter.js
 **/